var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-lg p-3" },
    [
      _c("h2", { staticClass: "text-center mt-5" }, [
        _vm._v(" " + _vm._s(_vm.T.wordsProblems) + " ")
      ]),
      _c("div", { staticClass: "d-flex justify-content-end" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary mb-2",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                _vm.showFinderWizard = true
              }
            }
          },
          [_vm._v(" " + _vm._s(_vm.T.wizardLinkText) + " ")]
        )
      ]),
      _c(
        "div",
        { staticClass: "d-flex align-items-center search-header-sticky-top" },
        [
          _c("omegaup-problem-search-bar", {
            staticClass: "searchbar-width",
            attrs: {
              language: _vm.language,
              languages: _vm.languages,
              keyword: _vm.keyword,
              tags: _vm.tags,
              "only-quality-seal": _vm.onlyQualitySeal,
              "search-result-problems": _vm.searchResultProblems
            },
            on: {
              "update-search-result-problems": function(query) {
                return _vm.$emit("update-search-result-problems", query)
              }
            }
          })
        ],
        1
      ),
      _c("omegaup-problem-finder", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showFinderWizard,
            expression: "showFinderWizard"
          }
        ],
        attrs: { "possible-tags": _vm.wizardTags },
        on: {
          close: function($event) {
            _vm.showFinderWizard = false
          },
          "search-problems": _vm.wizardSearch
        }
      }),
      _c("omegaup-problem-base-list", {
        attrs: {
          problems: _vm.problems,
          "logged-in": _vm.loggedIn,
          "selected-tags": _vm.selectedTags,
          "pager-items": _vm.pagerItems,
          "wizard-tags": _vm.wizardTags,
          language: _vm.language,
          languges: _vm.languages,
          keyword: _vm.keyword,
          modes: _vm.modes,
          columns: _vm.columns,
          mode: _vm.modes,
          column: _vm.column,
          tags: _vm.tags,
          "sort-order": _vm.sortOrder,
          "column-name": _vm.columnName,
          path: "/problem/"
        },
        on: {
          "apply-filter": function(columnName, sortOrder) {
            return _vm.$emit("apply-filter", columnName, sortOrder)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }